module.exports = __webpack_public_path__ + "static/media/logo-anage.0b26457d.svg";